import { TemplatesHttpClient } from '../../api';
const NAMESPACE = '/templates/projects';
class ProjectTemplateHTTPClient extends TemplatesHttpClient {
    getAllTemplates() {
        return this.get(NAMESPACE);
    }
    getPhases() {
        return this.get(`${NAMESPACE}/get-phases`);
    }
}
export const ProjectTemplatesAPI = new ProjectTemplateHTTPClient();
